module.exports = __webpack_public_path__ + "img/3.596e70f8.png";